import React, { useEffect, useRef, useState } from 'react';
import './ViolationPage.scss';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router';
import {
  getFilterData,
  getJsonFromStorage,
  getPaginationOpts, getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import { getViolationData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { VIOLATIONS_MODULE } from '../../../configs/moduleNames';
import { importViolation, loadControlWorkViolationsList } from '../actions';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import { Icons, Button } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { POPUP_LIST_NAME } from '../../../configs';
import { addGlobalPopUpWrapper, closeAllPopupWrapper } from '../../InformationScreenWrapper/actions';
import {
  dateFormatter, getLegalEntityName, localeFormatter, userFIOFormatter,
} from '../../../utils/formatters';
import FilterModal from '../../FilterTemplate/components/FilterModal';
import { PAGE_TYPE } from '../../FilterTemplate/components/filter-settings';
import RegistryImport from '../../RegionRegistry/components/RegistryImport';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import ExportInterface from '../../System/components/ExportInterface';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';

export default function ViolationsControlWorkPage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const store = useStore();
  const { updatePeriod } = useSelector(getSystemData);
  const {
    violationControlWorkList,
    violationControlWorkListMeta,
    loadingViolationControlWorkList,
  } = useSelector(getViolationData);
  const filterName = 'violations-control-work';
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const violation_id = searchParams.get('violation_id');
  const { formatMessage } = useIntl();
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[VIOLATIONS_MODULE].violationControlWorkListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: { ...getValues() },
      sort,
    };
    const p1 = dispatch(loadControlWorkViolationsList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  useEffect(() => {
    if (violation_id) {
      dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.VIOLATION_CONTROL_WORK_DETAIL, id: violation_id })));
    }
  }, [violation_id]);

  const handleImport = files => {
    if (!files) {
      return;
    }
    const data = new FormData();
    for (let i = 0, len = files.length; i < len; i++) {
      const file = files[i];
      data.append('file', file);
    }
    dispatch(importViolation(data))
      .then(() => successNotification('Импорт нарушений', 'Процесс импорта прошел успешно'))
      .catch(response => errorNotification('Импорт нарушений', getResponseError(response)));
    setShowImport(false);
  };

  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };

  const violationColumns = [
    {
      dataField: 'driver',
      text: 'ФИО водителя',
      formatter: item => userFIOFormatter({
        first_name: item?.driver_first_name,
        middle_name: item?.driver_middle_name,
        last_name: item?.driver_last_name,
      }),
      disableSort: true,
    },
    {
      dataField: 'driver',
      text: 'Водительское удостоверение',
      formatter: item => `${item?.driver_license_series || ''} ${item?.driver_license_number || ''} `,
      disableSort: true,
    },
    {
      dataField: 'applicant',
      text: 'Наименование перевозчика',
      formatter: getLegalEntityName,
      disableSort: true,
    },
    {
      dataField: 'type',
      text: 'Тип нарушения',
      formatter: item => localeFormatter('work_rest_violation_type', item),
    },
    {
      dataField: 'violation_date',
      text: 'Дата нарушения',
      formatter: dateFormatter,
    },
    {
      dataField: 'vehicle',
      text: 'ГРН ТС',
      formatter: item => item?.vehicle_lpn || '',
      disableSort: true,
    },
  ];

  const moreFormatter = (_, item) => null;

  useEffect(() => reset(getFilterData(filterName, {})), []);
  const {
    getValues, watch, control, reset,
  } = useForm({ defaultValues: getJsonFromStorage('violation-page-filter', {}) });

  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem(filterName, JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const [sort, setSort] = useState('-created_at');

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => () => dispatch((closeAllPopupWrapper())), []);

  useEffect(() => { loadData(); }, [sort]);
  return (
    <div className="page violation-page">
      <TimerLoader global loading={loadingViolationControlWorkList} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.violations_control_work' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
          />
          <div className="filter-sep" />
          <Button
            variant="second"
            onClick={() => {
              setShowImport(true);
            }}
            disabled
          >
            <Icons
              customIcon
              className="file-download"
              width={24}
              height={24}
              icon="import"
            />
          </Button>
          <div className="filter-sep" />
          <ExportInterface page="work_rest_violations" exporter="work_rest_violations" getValues={getValues} />
          <div className="filter-sep" />
          <Button variant="second" onClick={() => setOpenFilter(true)}>
            <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
          {isOpenFilter
            ? (
              <FilterModal
                control={control}
                onClose={() => setOpenFilter(false)}
                getValues={getValues}
                reset={reset}
                defaultValues={{}}
                page={PAGE_TYPE.VIOLATIONS_WORK_CONTROL}
              />
            )
            : null}
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                data={violationControlWorkList}
                rowClassFormatter={rowClassFormatter}
                columns={violationColumns}
                name="violations-list"
                changeSort={changeSort}
                sort={sort}
                onDoubleClickByRow={item => {
                  dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.VIOLATION_CONTROL_WORK_DETAIL, id: item?.id })));
                }}
                settingsFormatter={moreFormatter}
              />
            </div>
          </div>
          <Pagination meta={violationControlWorkListMeta} list={violationControlWorkList} handleChangeMeta={loadData} />
          {showImport ? <RegistryImport title="Импорт нарушения" handleImport={handleImport} onClose={() => setShowImport(false)} /> : null}
        </div>
      </div>
    </div>
  );
}
